import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65bd56c5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=65bd56c5&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=65bd56c5&lang=scss&scoped=true"
import style2 from "./index.vue?vue&type=style&index=2&id=65bd56c5&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bd56c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65bd56c5')) {
      api.createRecord('65bd56c5', component.options)
    } else {
      api.reload('65bd56c5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=65bd56c5&scoped=true", function () {
      api.rerender('65bd56c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/layout-preview/index.vue"
export default component.exports